// src/utils/httpSerialize.js
export const okRes = (res) => ({
  ok: true,
  status: res?.status ?? null,
  statusText: res?.statusText ?? "",
  data: res?.data ?? null,
});

export const errRes = (err) => {
  const r = err?.response;
  return {
    ok: false,
    message: err?.message ?? "Request failed",
    status: r?.status ?? null,
    statusText: r?.statusText ?? "",
    data: r?.data ?? null,
  };
};
